import { BaseSearchDTO } from "../../../../../uinspect/src/app/global/interfaces";

export interface UInspectQuestionSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
  };
}
